import { useQuery } from '@tanstack/react-query';
import { useAuthStore } from '@stores/auth';
import { notificationsApi } from '../api/notificationsApi';

/**
 * Bell-badge counter. Polls every 60s as a safety net; the SSE stream
 * (`useNotificationsStream`) invalidates this query on every new notification
 * so the badge usually updates within milliseconds without waiting on poll.
 */
export function useUnreadCount(enabled = true) {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);

  return useQuery({
    queryKey: ['notifications', 'unread-count'],
    queryFn: notificationsApi.unreadCount,
    enabled: enabled && isAuthenticated,
    refetchInterval: 60_000,
    refetchOnWindowFocus: true,
    staleTime: 30_000,
  });
}
